import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slot", "addButton"]
  static values = { visible: { type: Number, default: 1 } }

  connect() {
    this.visibleCount = Math.max(this.visibleValue, this.prefilledCount())
    this.update()
  }

  add(event) {
    event.preventDefault()
    this.visibleCount = Math.min(this.slotTargets.length, this.visibleCount + 1)
    this.update()
  }

  prefilledCount() {
    let count = 1

    this.slotTargets.forEach((slot, index) => {
      const hasValue = Array.from(slot.querySelectorAll("input")).some((input) => input.value.trim().length > 0)
      if (hasValue) count = index + 1
    })

    return count
  }

  update() {
    this.slotTargets.forEach((slot, index) => {
      slot.classList.toggle("hidden", index >= this.visibleCount)
    })

    if (this.hasAddButtonTarget) {
      const remaining = this.slotTargets.length - this.visibleCount
      this.addButtonTarget.classList.toggle("hidden", remaining <= 0)
      this.addButtonTarget.querySelector("[data-recipient-slots-label]")?.replaceChildren(
        document.createTextNode(remaining === 1 ? "Add one more" : `Add one more (${remaining} slots left)`)
      )
      this.addButtonTarget.querySelector("[data-recipient-slots-subtitle]")?.replaceChildren(
        document.createTextNode(remaining === 1 ? "You've got 1 slot left." : `You've got ${remaining} slots left.`)
      )
    }
  }
}
